import { FC, useState } from 'react';
import api from '@src/api/axiosInstance';
import { useTranslation } from 'react-i18next';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

import styles from './ChatMessageDocument.pcss';
import { Message } from '@src/types/messages';
import { generateDocumentLink, getHeaderFileLink } from '@src/helpers/MessageHelper';

interface ChatMessageDocumentProps {
	data: Message;
}

const ChatMessageDocument: FC<ChatMessageDocumentProps> = ({ data }) => {
	const { t } = useTranslation();
	const [busy,setBusy]=useState(false);
	const link=generateDocumentLink(data) ?? getHeaderFileLink(data,'document');
	const download=async(event: React.MouseEvent)=>{
		if(window.config?.APP_ENV_NAME!=='cvparc-shadow')return;
		// Explicit template links are separate from stored attachments; never
		// send our authentication headers to an external destination.
		if(link && new URL(link,window.location.href).origin!==window.location.origin)return;
		event.preventDefault();if(busy)return;
		if(!link){window.displayCustomError('Este archivo no está disponible.');return;}
		setBusy(true);
		try {
			// link already includes /api/v1; do not prepend Axios's base again.
			const response=await api.get(new URL(link,window.location.href).href,{responseType:'blob'});
			const url=URL.createObjectURL(response.data);
			const a=document.createElement('a');a.href=url;a.download=data.waba_payload?.document?.filename || 'documento';document.body.appendChild(a);a.click();a.remove();
			setTimeout(()=>URL.revokeObjectURL(url),60000);
		}catch{window.displayCustomError('No se ha podido descargar el archivo. Puede no estar disponible o tu sesión haber caducado.');}
		finally{setBusy(false);}
	};

	return (
		<a
			className={styles.documentMessage}
			href={link}
			onClick={download}
			aria-busy={busy}
			download={data.waba_payload?.document?.filename}
			target="_blank"
		>
			<InsertDriveFileIcon fontSize="small" />
			<span className={styles.documentMessageFilename}>
				{data.waba_payload?.document?.caption ??
					data.waba_payload?.document?.filename ??
					t('Document')}
			</span>
		</a>
	);
};

export default ChatMessageDocument;
